import { MooringArrivalLineHandling } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_ARRIVAL_LINE_HANDLING_DATA_TAG = 'MooringArrivalLineHandling';
class OldPortTransformer extends PropTransformer {
    toGateway() {
        return undefined;
    }
    fromGateway(port) {
        if (port) {
            return { port };
        }
        return {};
    }
}
export default class MooringArrivalLineHandlingParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL_LINE_HANDLING, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_ARRIVAL_LINE_HANDLING, MOORING_ARRIVAL_LINE_HANDLING_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            portOfCall: new OldPortTransformer(),
            port: 'port',
            type: 'type',
            line: 'line',
            lineArrangement: 'lineArrangement',
            alongside: 'alongside',
            berth: 'berth',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringArrivalLineHandling(props.port, props.type, props.line, props.lineArrangement, props.alongside, props.berth, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringArrivalLineHandlingParser.js.map